// extracted by mini-css-extract-plugin
export default {"container":"PageHeader__container-hcud5"};